"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomizerMutationsContext = void 0;
function createCustomizerMutationsContext() {
    return {
        insight: [],
        kpi: [],
        layouts: {},
    };
}
exports.createCustomizerMutationsContext = createCustomizerMutationsContext;
//# sourceMappingURL=types.js.map